import React from "react";
import { Button } from "../Component";

/**
 * Shared admin drawer (same pattern as TeleconsultationPendingPartners: backdrop z-1039, panel z-1040).
 */
export function AdminSideDrawer({ open, onClose, title, subtitle, children, footer, ariaLabel = "Close panel" }) {
  if (!open) return null;
  return (
    <>
      <button
        type="button"
        className="modal-backdrop fade show border-0 p-0"
        style={{ zIndex: 1039, cursor: "pointer" }}
        aria-label={ariaLabel}
        onClick={onClose}
      />
      <aside
        className="position-fixed bg-white border-start shadow-sm d-flex flex-column"
        style={{
          top: 0,
          right: 0,
          width: "min(440px, 100vw)",
          height: "100vh",
          zIndex: 1040,
        }}
      >
        <div className="border-bottom p-3 d-flex align-items-start justify-content-between">
          <div className="min-w-0">
            {title ? <h6 className="title mb-1 text-truncate">{title}</h6> : null}
            {subtitle ? <p className="small text-soft mb-0 text-break">{subtitle}</p> : null}
          </div>
          <Button color="light" size="sm" className="flex-shrink-0" type="button" onClick={onClose}>
            Close
          </Button>
        </div>
        <div className="flex-grow-1 overflow-auto p-3 small">{children}</div>
        {footer ? (
          <div className="border-top p-3 d-flex flex-wrap align-items-center">
            {React.Children.map(React.Children.toArray(footer), (child, idx) => (
              <span key={idx} className="mr-2 mb-2 d-inline-flex align-items-center">
                {child}
              </span>
            ))}
          </div>
        ) : null}
      </aside>
    </>
  );
}

export default AdminSideDrawer;
